import React from 'react'
import { RadBox } from '../common/RadBox'
import { RadButton } from '../common/RadButton'
import { RadContainer } from '../common/RadContainer'
import { RadCopyToClipboard } from '../common/RadCopyToClipboard'
import { RadGrid } from '../common/RadGrid'
import { RadLink } from '../common/RadLink'
import { RadSpaceBetween } from '../common/RadSpaceBetween'

export function OrganizationDetailContent ({ organization, setSelectedEntity }) {
  if (organization == null) {
    return null
  }

  return (
    <RadSpaceBetween size='l'>
      <div>
        <RadBox variant='awsui-key-label' display='inline'>
          SECTOR(S):
        </RadBox>
        <RadBox variant='span' padding={{ left: 'xs' }}>
          {organization.sectors.map(x => x.sector.name).join(', ') || '-'}
        </RadBox>
      </div>

      <RadGrid
        gridDefinition={[
          { colspan: { default: 12, xs: 8 } },
          { colspan: { default: 12, xs: 4 } }
        ]}
      >
        <RadSpaceBetween size='s'>
          <RadBox>{organization.description}</RadBox>

          <br />

          <RadCopyToClipboard
            copyButtonText='Copy link'
            copyErrorText='Link failed to copy'
            copySuccessText='Link copied'
            textToCopy={`${window.location.origin}/organization/${organization.id}`}
          />
        </RadSpaceBetween>

        <RadContainer className='gray-background'>
          <RadSpaceBetween size='s'>
            <RadBox variant='h3'>
              Organization Details
            </RadBox>

            <div>
              <RadBox variant='awsui-key-label'>
                Type
              </RadBox>
              <div>{organization.type?.name ?? '-'}</div>
            </div>

            <div>
              <RadBox variant='awsui-key-label'>
                Address
              </RadBox>
              <div>{organization.address?.line1}</div>
              {organization.address?.line2 && <div>{organization.address?.line2}</div>}
              <div>{organization.address?.city} {organization.address?.state} {organization.address?.zip}</div>
              {!organization.addressId && '-'}
            </div>

            <div>
              <RadBox variant='awsui-key-label'>
                Website
              </RadBox>
              <div>{
            organization.website != null
              ? <RadLink href={organization.website} target='_blank' rel='noopener noreferrer'>{organization.website}</RadLink>
              : '-'
          }
              </div>
            </div>

            {
              organization.contacts != null &&
                <div>
                  <RadBox variant='awsui-key-label'>
                    Contacts
                  </RadBox>
                  <div>{organization.contacts.length > 0
                    ? organization.contacts.map((x) => <div key={x.id}>{x.name}</div>)
                    : '-'}
                  </div>
                </div>
            }

            <div>
              <RadBox variant='awsui-key-label'>
                Services
              </RadBox>
              <div>{
            organization.services?.length > 0
              ? organization.services.map((x) => <div key={x.id}>{x.service?.name}</div>)
              : '-'
          }
              </div>
            </div>

            <div>
              <RadBox variant='awsui-key-label'>
                Priority Areas
              </RadBox>
              <div>{organization.targetAreas?.length > 0 ? organization.targetAreas.map((x) => <div key={x.id}>{x.targetArea.name}</div>) : '-'}</div>
            </div>

            <div>
              <RadBox variant='awsui-key-label'>
                Priority Populations
              </RadBox>
              <div>{organization.targetPopulations?.length > 0 ? organization.targetPopulations.map((x) => <div key={x.id}>{x.targetPopulation.name}</div>) : '-'}</div>
            </div>

            <div>
              <RadBox variant='awsui-key-label'>
                Projects
              </RadBox>
              <div>{organization.projects?.length > 0
                ? organization.projects.map((x) =>
                  <div key={x.id}>
                    {setSelectedEntity == null && <RadLink href={`/project/${x.project.id}`}>{x.project?.name}</RadLink>}
                    {setSelectedEntity != null &&
                      <RadButton
                        onClick={() => setSelectedEntity({ type: 'project', id: x.project.id })}
                        className='font-weight-400'
                        variant='inline-link'
                      >
                        {x.project?.name}
                      </RadButton>}
                  </div>
                )
                : '-'}
              </div>
            </div>

            <div>
              <RadBox variant='awsui-key-label'>
                Collaboratives
              </RadBox>
              <div>{organization.collaboratives?.length > 0
                ? organization.collaboratives.map((x) =>
                  <div key={x.id}>
                    {setSelectedEntity == null && <RadLink href={`/collaborative/${x.collaborative.id}`}>{x.collaborative.name}</RadLink>}
                    {setSelectedEntity != null &&
                      <RadButton
                        onClick={() => setSelectedEntity({ type: 'collaborative', id: x.collaborative.id })}
                        className='font-weight-400'
                        variant='inline-link'
                      >
                        {x.collaborative.name}
                      </RadButton>}
                  </div>)
                : '-'}
              </div>
            </div>

            <div>
              <RadBox variant='awsui-key-label'>
                Framework Tags
              </RadBox>
              {organization.tags.map(x => x.tag.name).join(', ') || '-'}
            </div>
          </RadSpaceBetween>
        </RadContainer>
      </RadGrid>

    </RadSpaceBetween>
  )
}
